import cpPlusLogo from "../../../assets/images/logo/Logo_Cleanproplus-white.png";
import { getStoreType, logoController } from "../../../dynamicController";
import { connect } from "react-redux";

const STORETYPE = getStoreType()

const Maintainance = ({ themeLogo }) => {
    return (
        <div className="admin-bgImg">
            <div id="user-header"></div>
            <div>
                <div className="mt-3 px-3">

                    <div className="container-fluid d-flex flex-column justify-content-center align-items-center min-vh-100">
                        {/* Logo Section */}
                        <div className="text-center mb-4">
                            <img
                                src={logoController(themeLogo)}
                                alt="logo"
                                className="img-fluid"
                                style={{ maxWidth: "200px" }}
                            />
                            {STORETYPE === "cleanpro" && (
                                <img className="pt-2 d-block mx-auto" src={cpPlusLogo} alt="" />
                            )}
                        </div>

                        {/* Maintenance Message */}
                        <div className="text-center px-3 mb-4">
                            <div className="maintenance-icon mb-3">
                                <i className="fas fa-tools" style={{ fontSize: "4rem", opacity: "0.7" }}></i>
                            </div>

                            <h1 className="thankyou-title mb-3">
                                System Maintenance
                            </h1>

                            <div className="thankyou-title">
                                <p className="lead mb-3">
                                    We're currently performing scheduled maintenance to improve your experience.
                                </p>

                                <p className="thankyou-title mb-4">
                                    The loyalty system will be back online shortly. Thank you for your patience!
                                </p>

                                {/* <div className="alert alert-info d-inline-block">
                                    <i className="fas fa-info-circle me-2"></i>
                                    Estimated downtime: 15-30 minutes
                                </div> */}
                            </div>
                        </div>

                        {/* Additional Info */}
                        {/* <div className="thankyou-title text-center">
                            <small className="text-muted">
                                For urgent assistance, please contact our support team.
                            </small>
                        </div> */}
                    </div>

                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        themeLogo: state.theme.logo,
    };
};

export default connect(mapStateToProps, null)(Maintainance);